import { render, staticRenderFns } from "./VisitCountdown.vue?vue&type=template&id=5b3f5bec&scoped=true&"
import script from "./VisitCountdown.vue?vue&type=script&lang=js&"
export * from "./VisitCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f5bec",
  null
  
)

export default component.exports